import { LayoutTypes, ButtonVariant, NavLinkStyleTypes } from "../types";

export const getMainMenuItems = (layoutType = LayoutTypes.home) => {

  const baseUrl = '/'; //process.env.REACT_APP_SOPHINEX_DOMAIN_BASE_URL;

  return {
    baseUrl,
    menuItems: [
      {
        title: 'WHY TRUST US',
        path: baseUrl,
        hash: 'why-trust-us'
      },
      {
        title: 'HOW IT WORKS',
        path: baseUrl,
        hash: 'workflow',
        isScrollNav: false 
      },
      {
        title: 'TESTIMONIALS',
        path: baseUrl,
        hash: 'testimonials'
      },
      {
        title: 'FAQ',
        path: `${baseUrl}faq`,
        isScrollNav: false 
      },
      {
        title: 'CONTACT US',
        path: `${baseUrl}contact-us`,
        isScrollNav: false 
      }
    ],
    menuButton: {
      title: 'Get Free Offer',
      path: baseUrl,
      hash: 'get-offer',
      isExternalLink: false,
      isScrollNav: true, 
      style: NavLinkStyleTypes.button,
      variant: ButtonVariant.success,
      dark: false,
      alt: 'Get Free Offer'
    },
    layoutType
  };
};